// Alert
export const CLOSE_ALERT = 'CLOSE_ALERT';
export const OPEN_ALERT = 'OPEN_ALERT';

// Auth
export const FETCH_AUTH = 'FETCH_AUTH';
export const FETCH_AUTH_FAILED = 'FETCH_AUTH_FAILED';
export const FETCH_AUTH_SUCCESS = 'FETCH_AUTH_SUCCESS';
export const SET_AUTH = 'SET_AUTH';
export const REVOKE_AUTH = 'REVOKE_AUTH';